import { UserBasicDetails } from "services/common"

import { getCookie, setCookie } from "./cookies"

export const setAuthToken = (value: string) =>
  setCookie(
    `wAT${process.env.REACT_APP_IS_PRODUCTION || ""}` || "wAT",
    value,
    365 * 2,
  )

export const getAuthToken = () =>
  getCookie(`wAT${process.env.REACT_APP_IS_PRODUCTION || ""}` || "wAT")

export const removeAuthToken = () =>
  setCookie(
    `wAT${process.env.REACT_APP_IS_PRODUCTION || ""}` || "wAT",
    "",
    365 * 2,
  )

export const setUserCookie = (value: UserBasicDetails | undefined) =>
  setCookie(
    `ubD${process.env.REACT_APP_IS_PRODUCTION || ""}`,
    (value && JSON.stringify(value)) || "",
    365 * 2,
  )
export const getUserCookie = () =>
  getCookie(`ubD${process.env.REACT_APP_IS_PRODUCTION || ""}`)
    ? (JSON.parse(
        getCookie(`ubD${process.env.REACT_APP_IS_PRODUCTION || ""}`),
      ) as UserBasicDetails)
    : undefined

export const setTempAuthToken = (value: string) =>
  setCookie(process.env.REACT_APP_TEMP_TOKEN_NAME || "whTAT", value, 365 * 2)

export const getTempAuthToken = () =>
  getCookie(process.env.REACT_APP_TEMP_TOKEN_NAME || "whTAT")

export const removeTempAuthToken = () =>
  setCookie(process.env.REACT_APP_TEMP_TOKEN_NAME || "whTAT", "", 365 * 2)

export const setReCaptchaToken = (value: string) =>
  setCookie("rCT", value || "amish", 365 * 2)

export const getReCaptchaToken = () => getCookie("rCT")

export const removeReCaptchaToken = () => setCookie("rCT", "", 365 * 2)

export const setTableRowCount = (value: string) =>
  localStorage.setItem("tableRowsCount", value)

export const getTableRowCount = () =>
  localStorage.getItem("tableRowsCount") || "5"

export const setPageCount = (value: string) =>
  sessionStorage.setItem("pageCount", value)

export const getsetPageCount = () => sessionStorage.getItem("pageCount") || "0"

export const setSelectedPMCId = (value: string) =>
  localStorage.setItem("selectedPMC", value)

export const getSelectedPMCId = () => localStorage.getItem("selectedPMC") || ""

export const setSelectedPMCIdC = (value: string) =>
  localStorage.setItem("selectedPMC", value)

export const setInviteAuth = (value: string) =>
  localStorage.setItem("inviteAuth", value)

export const getInviteAuth = () => localStorage.getItem("inviteAuth")

export const removeInviteAuth = () => localStorage.removeItem("inviteAuth")

export const setHostfullyPageOrigin = (value: string) =>
  localStorage.setItem("hostfullyPageOrigin", value)

export const getHostfullyPageOrigin = () =>
  localStorage.getItem("hostfullyPageOrigin")

export const removeHostfullyPageOrigin = () =>
  localStorage.removeItem("hostfullyPageOrigin")

//-------------------------------------------

const IsSpanishForHostfullySSOB = "IsSpanishForHostfullySSOB"
export const setIsSpanishForHostfullySSOB = (value: string) =>
  localStorage.setItem(IsSpanishForHostfullySSOB, value)

export const getIsSpanishForHostfullySSOB = () =>
  localStorage.getItem(IsSpanishForHostfullySSOB)

export const removeIsSpanishForHostfullySSOB = () =>
  localStorage.removeItem(IsSpanishForHostfullySSOB)
